import { Divider, TextField, Box, Grid, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateResourceSummary } from "../../redux-store/currentUserActions";
import { setResourceSummary } from '../../redux-store/currentUserSlice';
import AuthTypeText from "./AuthTypeText";
import TextFieldWithVariableTooltip from "components/Common/TextFieldWithVariableTooltip";

const BasicAuthorization = ({
  authorization, onAuthorizationUpdate,
}) => {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);
  const [password, setPassword] = useState(authorization?.password);
  const [username, setUsername] = useState(authorization?.username);

  const handleInputChange = (field, value) => {
    if (field === 'password') setPassword(value);
    else setUsername(value);
  };

  const handleApiCall = async () => {
    await onAuthorizationUpdate({
      authorization_value: {
        username: username,
        password: password
      }
    });
  };

  return (
    <Box p={2}>
      <AuthTypeText />
      <Divider sx={{ my: 2 }} />

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={3}>
          <Typography variant="body" sx={{ color: 'var(--text-primary)' }}>Username:</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextFieldWithVariableTooltip
            size="small"
            variant="outlined"
            value={username}
            onChange={(e) => handleInputChange('username', e.target.value)}
            onBlur={handleApiCall}
            style={{ width: '40%' }}
          />
        </Grid>

        <Grid item xs={3}>
          <Typography variant="body" sx={{ color: 'var(--text-primary)' }}>Password:</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextFieldWithVariableTooltip
            size="small"
            variant="outlined"
            type={isChecked ? "text" : "password"}
            value={password}
            onChange={(e) => handleInputChange('password', e.target.value)}
            onBlur={handleApiCall}
            style={{ width: '40%' }}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
                color="primary"
              />
            }
            label="Show Password"
            sx={{ color: 'var(--text-primary)' }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BasicAuthorization;
